import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-merge-gray",
  "use": "icon-merge-gray-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-merge-gray\"><path d=\"M588.8 179.2v256h256v409.6h-409.6v-256h-256V179.2h409.6M640 128H128v512h256v256h512V384h-256V128z\" fill=\"#707070\" p-id=\"36294\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol